(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}}');
    }
    try {
      var code =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function productHandleFromPath(pathname) {
    const match = pathname.match(/^\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function toHtml(str) {
    const div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  /** Normalize Shopify money fields to integer cents (integer = cents; decimal string = major units). */
  function parseMoneyCents(raw) {
    if (raw == null || raw === '') return NaN;
    const str = String(raw).trim();
    const n = Number(raw);
    if (!Number.isFinite(n)) return NaN;
    if (str.includes('.')) {
      return Math.round(n * 100);
    }
    return Math.round(n);
  }

  /** First variant compare_at vs price (Shopify /products/{handle}.js). */
  function variantPriceParts(product) {
    const v = product.variants && product.variants[0];
    if (!v) {
      const p = parseMoneyCents(product.price);
      return { priceCents: Number.isFinite(p) ? p : 0, compareCents: null };
    }
    let priceCents = parseMoneyCents(v.price);
    if (!Number.isFinite(priceCents)) {
      priceCents = parseMoneyCents(product.price);
    }
    if (!Number.isFinite(priceCents)) priceCents = 0;

    let compareCents = null;
    if (v.compare_at_price != null) {
      const co = parseMoneyCents(v.compare_at_price);
      if (Number.isFinite(co) && co > priceCents) {
        compareCents = co;
      }
    }

    return { priceCents, compareCents };
  }

  function recentlyViewedPriceRow(product) {
    const { priceCents, compareCents } = variantPriceParts(product);
    const priceStr = Number.isFinite(priceCents) ? formatMoney(priceCents) : '';
    if (!compareCents) {
      return `
        <div class="lyra-recently-viewed__price-row lyra-recently-viewed__price-row--single">
          <span class="lyra-recently-viewed__sale">${toHtml(priceStr)}</span>
        </div>`;
    }
    const pct = Math.max(0, Math.round((1 - priceCents / compareCents) * 100));
    return `
      <div class="lyra-recently-viewed__price-row">
        <s class="lyra-recently-viewed__compare">${toHtml(formatMoney(compareCents))}</s>
        <span class="lyra-recently-viewed__sale">${toHtml(priceStr)}</span>
        <span class="lyra-recently-viewed__badge">${pct}% OFF</span>
      </div>`;
  }

  function saveRecentlyViewedHandle() {
    const handle = productHandleFromPath(window.location.pathname);
    if (!handle) return;

    const key = 'lyra_recently_viewed_handles';
    let handles = [];
    try {
      handles = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(handles)) handles = [];
    } catch (err) {
      handles = [];
    }

    handles = handles.filter((entry) => entry !== handle);
    handles.unshift(handle);
    handles = handles.slice(0, 12);

    try {
      localStorage.setItem(key, JSON.stringify(handles));
    } catch (err) {
      // Ignore storage failures in private mode.
    }
  }

  function renderRecentlyViewedCards() {
    const key = 'lyra_recently_viewed_handles';
    let handles = [];

    try {
      handles = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(handles)) handles = [];
    } catch (err) {
      handles = [];
    }

    const currentHandle = productHandleFromPath(window.location.pathname);
    handles = handles.filter((handle) => handle && handle !== currentHandle);

    const containers = document.querySelectorAll('[data-lyra-recently-viewed]');
    if (!containers.length) return;

    containers.forEach((container) => {
      const limit = Number.parseInt(container.getAttribute('data-lyra-recent-limit') || '5', 10);
      const output = container.querySelector('[data-lyra-recent-grid]');
      if (!output) return;

      const selected = handles.slice(0, Math.max(limit, 1));
      if (!selected.length) {
        container.setAttribute('hidden', 'hidden');
        output.innerHTML = '';
        return;
      }

      container.removeAttribute('hidden');
      output.innerHTML = '';

      Promise.all(
        selected.map((handle) =>
          fetch(`/products/${handle}.js`)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Failed to load product for handle ${handle}`);
              }
              return response.json();
            })
            .catch(() => null)
        )
      ).then((products) => {
        const markup = products
          .filter(Boolean)
          .map((product) => {
            const image = product.featured_image || (product.images && product.images[0]) || '';
            const title = toHtml(product.title || 'Product');
            const url = toHtml(product.url || `/products/${product.handle}`);

            return `
              <a class="lyra-recently-viewed__card" href="${url}">
                <div class="lyra-recently-viewed__media">
                  ${image ? `<img loading="lazy" src="${toHtml(image)}" alt="${title}">` : ''}
                </div>
                <p class="lyra-recently-viewed__title">${title}</p>
                ${recentlyViewedPriceRow(product)}
              </a>
            `;
          })
          .join('');

        output.innerHTML = markup;
        if (!markup) {
          container.setAttribute('hidden', 'hidden');
        }
      });
    });
  }

  function refreshCartDrawerAfterAdd(payload) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    drawer.renderContents(payload);
    initCartCountdown();
  }

  function addUpsellToCart(variantId, quantity) {
    const cart = document.querySelector('cart-drawer');
    const formData = new FormData();

    formData.append('id', String(variantId));
    formData.append('quantity', String(quantity || 1));

    if (cart && typeof cart.getSectionsToRender === 'function') {
      const sections = cart.getSectionsToRender().map((section) => section.id);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((payload) => {
        if (payload && !payload.status) {
          refreshCartDrawerAfterAdd(payload);
          return;
        }

        window.location.href = window.routes.cart_url;
      })
      .catch(() => {
        window.location.href = window.routes.cart_url;
      });
  }

  function initCartUpsell() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-lyra-add-upsell]');
      if (!button) return;

      event.preventDefault();

      const block = button.closest('[data-lyra-upsell-product-id]');
      const selector = block && block.querySelector('[data-lyra-upsell-product-id][data-lyra-upsell-variant]');

      let variantId = null;

      if (selector && selector.tagName === 'SELECT') {
        variantId = selector.value;
      } else if (selector && selector.tagName === 'INPUT') {
        variantId = selector.value;
      }

      if (!variantId) {
        variantId = button.getAttribute('data-lyra-upsell-variant');
      }

      if (!variantId) return;

      button.setAttribute('disabled', 'disabled');
      addUpsellToCart(variantId, 1).finally(() => {
        button.removeAttribute('disabled');
      });
    });
  }

  function initCartCountdown() {
    const countdowns = document.querySelectorAll('[data-lyra-countdown]');
    if (!countdowns.length) return;

    countdowns.forEach((countdown) => {
      if (countdown.dataset.lyraCountdownInitialized === 'true') return;

      const fourPart = countdown.querySelector('[data-lyra-countdown-4]');
      const parts = fourPart ? countdown.querySelectorAll('[data-lyra-countdown-part]') : [];
      const target = countdown.querySelector('[data-lyra-countdown-display]');
      const useFourPart = fourPart && parts.length === 4;

      if (!target && !useFourPart) return;

      const minutes = Number.parseInt(countdown.getAttribute('data-lyra-countdown') || '10', 10);
      const durationMs = (Number.isFinite(minutes) && minutes > 0 ? minutes : 10) * 60 * 1000;
      const key = countdown.getAttribute('data-lyra-countdown-key') || 'lyra_cart_countdown_end';

      let endTime = Number.parseInt(sessionStorage.getItem(key) || '', 10);
      const now = Date.now();

      if (!Number.isFinite(endTime) || endTime <= now) {
        endTime = now + durationMs;
        sessionStorage.setItem(key, String(endTime));
      }

      function tick() {
        const remaining = Math.max(endTime - Date.now(), 0);
        const remainingSeconds = Math.floor(remaining / 1000);

        if (useFourPart) {
          const dd = String(Math.floor(remainingSeconds / 86400)).padStart(2, '0');
          const hh = String(Math.floor((remainingSeconds % 86400) / 3600)).padStart(2, '0');
          const mm = String(Math.floor((remainingSeconds % 3600) / 60)).padStart(2, '0');
          const ss = String(remainingSeconds % 60).padStart(2, '0');
          parts[0].textContent = dd;
          parts[1].textContent = hh;
          parts[2].textContent = mm;
          parts[3].textContent = ss;
        } else {
          const mm = String(Math.floor(remainingSeconds / 60)).padStart(2, '0');
          const ss = String(remainingSeconds % 60).padStart(2, '0');
          target.textContent = `${mm}:${ss}`;
        }

        if (remaining <= 0) {
          endTime = Date.now() + durationMs;
          sessionStorage.setItem(key, String(endTime));
        }
      }

      tick();
      setInterval(tick, 1000);
      countdown.dataset.lyraCountdownInitialized = 'true';
    });
  }

  function initAnnouncementCountdown() {
    const bars = document.querySelectorAll('[data-lyra-announcement-countdown]');
    if (!bars.length || typeof Intl === 'undefined' || typeof Intl.DateTimeFormat !== 'function') return;

    const formatter = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Sydney',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });

    const getSydneyTime = () => {
      const parts = formatter.formatToParts(new Date());
      const valueFor = (type) => Number.parseInt(parts.find((part) => part.type === type)?.value || '0', 10);
      return {
        hours: valueFor('hour'),
        minutes: valueFor('minute'),
        seconds: valueFor('second')
      };
    };

    bars.forEach((bar) => {
      if (bar.dataset.lyraAnnouncementInitialized === 'true') return;

      const hoursTarget = bar.querySelector('[data-lyra-announcement-part="hours"]');
      const minutesTarget = bar.querySelector('[data-lyra-announcement-part="minutes"]');
      const secondsTarget = bar.querySelector('[data-lyra-announcement-part="seconds"]');
      if (!hoursTarget || !minutesTarget || !secondsTarget) return;

      function tick() {
        const now = getSydneyTime();
        let totalSeconds = (23 - now.hours) * 3600 + (59 - now.minutes) * 60 + (60 - now.seconds);

        if (now.seconds === 0) {
          totalSeconds -= 60;
        }

        if (totalSeconds < 0) totalSeconds = 0;

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        hoursTarget.textContent = String(hours).padStart(2, '0');
        minutesTarget.textContent = String(minutes).padStart(2, '0');
        secondsTarget.textContent = String(seconds).padStart(2, '0');
      }

      tick();
      setInterval(tick, 1000);
      bar.dataset.lyraAnnouncementInitialized = 'true';
    });
  }

  function initMobileHeaderPolish() {
    const header = document.querySelector('.shopify-section-header');
    if (!header) return;

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('header-drawer summary');
      if (!summary) return;
      header.classList.toggle('lyra-mobile-menu-open', !summary.closest('details').hasAttribute('open'));
    });
  }

  function initNewsletterPopup() {
    const popup = document.querySelector('[data-lyra-newsletter-popup]');
    const teaser = document.querySelector('[data-lyra-newsletter-teaser]');
    if (!popup) return;
    if (popup.dataset.lyraNewsletterInit === 'true') return;

    const key = 'lyra_newsletter_popup_seen';
    const teaserKey = 'lyra_newsletter_teaser_dismissed';

    const showTeaser = () => {
      if (!teaser) return;
      if (sessionStorage.getItem(teaserKey) === 'true') return;
      teaser.removeAttribute('hidden');
    };

    const hideTeaser = () => {
      if (!teaser) return;
      teaser.setAttribute('hidden', 'hidden');
    };

    const openPopup = () => {
      hideTeaser();
      popup.removeAttribute('hidden');
      document.body.classList.add('lyra-newsletter-open');
    };

    if (popup.querySelector('[data-lyra-newsletter-success]')) {
      sessionStorage.setItem(key, 'true');
    }

    const closeButtons = popup.querySelectorAll('[data-lyra-newsletter-close]');
    const close = () => {
      popup.setAttribute('hidden', 'hidden');
      document.body.classList.remove('lyra-newsletter-open');
      sessionStorage.setItem(key, 'true');
      showTeaser();
    };

    closeButtons.forEach((button) => {
      button.addEventListener('click', close);
    });

    const form = popup.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => {
        sessionStorage.setItem(key, 'true');
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hasAttribute('hidden')) close();
    });

    if (teaser) {
      const teaserOpenBtn = teaser.querySelector('[data-lyra-teaser-open]');
      const teaserCloseBtn = teaser.querySelector('[data-lyra-teaser-close]');

      if (teaserOpenBtn) {
        teaserOpenBtn.addEventListener('click', openPopup);
      }

      if (teaserCloseBtn) {
        teaserCloseBtn.addEventListener('click', () => {
          hideTeaser();
          sessionStorage.setItem(teaserKey, 'true');
        });
      }

      // Show teaser immediately on every page load (unless dismissed)
      showTeaser();
    }

    if (sessionStorage.getItem(key) === 'true') {
      popup.dataset.lyraNewsletterInit = 'true';
      return;
    }

    const delaySeconds = Number.parseInt(popup.getAttribute('data-lyra-newsletter-delay') || '2', 10);
    const delayMs = Number.isFinite(delaySeconds) && delaySeconds >= 0 ? delaySeconds * 1000 : 2000;

    setTimeout(() => {
      if (sessionStorage.getItem(key) === 'true') return;
      hideTeaser();
      popup.removeAttribute('hidden');
      document.body.classList.add('lyra-newsletter-open');
    }, delayMs);

    popup.dataset.lyraNewsletterInit = 'true';
  }

  function initOfferTicker() {
    const tickers = document.querySelectorAll('[data-lyra-offer-ticker]');
    if (!tickers.length) return;

    tickers.forEach((ticker) => {
      if (ticker.dataset.lyraOfferInit === 'true') return;

      const items = Array.from(ticker.querySelectorAll('.lyra-discount-ticker__item'));
      if (!items.length) return;

      let activeIndex = Math.max(
        items.findIndex((item) => item.classList.contains('is-active')),
        0
      );

      const show = (index) => {
        items.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === index);
        });
      };

      show(activeIndex);

      if (items.length > 1) {
        const speed = Number.parseInt(ticker.getAttribute('data-lyra-offer-speed') || '4000', 10);
        const intervalMs = Number.isFinite(speed) && speed >= 1500 ? speed : 4000;
        setInterval(() => {
          activeIndex = (activeIndex + 1) % items.length;
          show(activeIndex);
        }, intervalMs);
      }

      ticker.dataset.lyraOfferInit = 'true';
    });
  }

  function initFakeRatings() {
    const fakeRatings = document.querySelectorAll('[data-lyra-fake-rating]');
    if (!fakeRatings.length) return;

    fakeRatings.forEach((item) => {
      if (item.dataset.lyraFakeRatingInit === 'true') return;

      const ratingEl = item.querySelector('[data-lyra-fake-rating-number]');
      const countEl = item.querySelector('[data-lyra-fake-rating-count]');
      if (!ratingEl || !countEl) return;

      const rating = (4.6 + Math.random() * 0.3).toFixed(1);
      const reviews = Math.floor(3501 + Math.random() * 2500);

      ratingEl.textContent = rating;
      countEl.textContent = String(reviews);
      item.dataset.lyraFakeRatingInit = 'true';
    });
  }

  function initDesktopHeaderHoverMenus() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    const detailsElements = document.querySelectorAll('.header__inline-menu header-menu > details');
    if (!detailsElements.length) return;

    detailsElements.forEach((details) => {
      if (details.dataset.lyraHoverInit === 'true') return;

      let closeTimeout = null;

      details.addEventListener('mouseenter', () => {
        if (closeTimeout) window.clearTimeout(closeTimeout);
        details.setAttribute('open', 'open');
      });

      details.addEventListener('mouseleave', () => {
        closeTimeout = window.setTimeout(() => {
          details.removeAttribute('open');
        }, 100);
      });

      details.dataset.lyraHoverInit = 'true';
    });
  }

  function initOpenCartFromQuery() {
    const url = new URL(window.location.href);
    const shouldOpen = url.searchParams.get('open_cart') === '1';
    if (!shouldOpen) return;

    const drawer = document.querySelector('cart-drawer');
    const trigger = document.querySelector('#cart-icon-bubble');
    if (!drawer || typeof drawer.open !== 'function') return;

    setTimeout(() => {
      drawer.open(trigger || undefined);
    }, 80);

    url.searchParams.delete('open_cart');
    url.searchParams.delete('drawer_redirect');
    const next =
      url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : '') + url.hash;
    window.history.replaceState({}, document.title, next);
  }

  function init() {
    saveRecentlyViewedHandle();
    renderRecentlyViewedCards();
    initCartCountdown();
    initAnnouncementCountdown();
    initCartUpsell();
    initMobileHeaderPolish();
    initNewsletterPopup();
    initOfferTicker();
    initFakeRatings();
    initDesktopHeaderHoverMenus();
    initOpenCartFromQuery();
  }

  window.lyraInitCartCountdown = initCartCountdown;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    renderRecentlyViewedCards();
    initCartCountdown();
    initAnnouncementCountdown();
    initNewsletterPopup();
    initOfferTicker();
    initFakeRatings();
    initDesktopHeaderHoverMenus();
  });
})();
